webpackJsonp([143],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(141)("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SWITCH_EFFECT; });
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

var functions = {
  isGroupMember: function isGroupMember(component, groupname) {
    if (component.$auth.check()) {
      console.log(component.$auth.watch.data['cognito:groups']);
      for (var i = 0; i < component.$auth.watch.data['cognito:groups'].length; i++) {
        if (component.$auth.watch.data['cognito:groups'][i] === groupname) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  },
  jsonpretty: function jsonpretty(data) {
    return JSON.stringify(data, null, 2);
  }
};

module.exports = functions;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(277)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(360),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__echo__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noti__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__house__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__device__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parking__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nexia__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parcel__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visitor__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visitorVehicle__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vote__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contact__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bill__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ems__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pushnotification__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__serviceinfo__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__elevator__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cctv__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__homeiotdashboard__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__userinfo__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__notificationRequest__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__connectorInfo__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__centralPage__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__evcharge__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__legalInfo__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__brandInfo__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__linkedService__ = __webpack_require__(191);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


// import lazyLoading from './lazyLoading'
// import charts from './charts'
// import uifeatures from './uifeatures'
// import components from './components'
// import tables from './tables'


























// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [
  // {
  //   name: 'Dashboard',
  //   path: '/dashboard',
  //   meta: {
  //     icon: 'fal fa-tachometer-alt',
  //     link: 'dashboard/index.vue'
  //   },
  //   component: lazyLoading('dashboard', true)
  // },
  // {
  //   name: 'Axios',
  //   path: '/axiosDemo',
  //   meta: {
  //     auth: false,
  //     icon: 'fa-rocket',
  //     link: 'axios/index.vue'
  //   },
  //   component: lazyLoading('axios', true)
  // },
  // charts,
  // uifeatures,
  // components,
  // tables,
  __WEBPACK_IMPORTED_MODULE_3__house__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__centralPage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__device__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__elevator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__bill__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__brandInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__cctv__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__ems__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__evcharge__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__legalInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__linkedService__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__noti__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__notificationRequest__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__parcel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__parking__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__pushnotification__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__serviceinfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__visitor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__visitorVehicle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__vote__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__userinfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__nexia__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__homeiotdashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__connectorInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__echo__["a" /* default */]]
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 85 */,
/* 86 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(275)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(358),
  /* scopeId */
  "data-v-65809695",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(349),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(356),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(330);


__WEBPACK_IMPORTED_MODULE_0__app__["a" /* app */].$mount('#app');

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Home.vue": [
		135
	],
	"./auth/Callback-OAuth.vue": [
		450,
		140
	],
	"./auth/Login-OAuth.vue": [
		451,
		139
	],
	"./auth/Login.vue": [
		452,
		124
	],
	"./auth/Personal-Token.vue": [
		136
	],
	"./axios/index.vue": [
		453,
		7
	],
	"./charts/Chartist.vue": [
		454,
		100
	],
	"./charts/Chartjs.vue": [
		455,
		6
	],
	"./charts/Peity.vue": [
		456,
		126
	],
	"./charts/Plotly.vue": [
		457,
		110
	],
	"./charts/index.vue": [
		458,
		138
	],
	"./components/BackToTop.vue": [
		459,
		137
	],
	"./components/Brace.vue": [
		460,
		5
	],
	"./components/Collapse.vue": [
		461,
		61
	],
	"./components/Datepicker.vue": [
		462,
		58
	],
	"./components/Default.vue": [
		463,
		108
	],
	"./components/Emoji.vue": [
		464,
		98
	],
	"./components/Lory.vue": [
		465,
		52
	],
	"./components/Message.vue": [
		466,
		107
	],
	"./components/Modal.vue": [
		467,
		49
	],
	"./components/Notification.vue": [
		468,
		106
	],
	"./components/ProgressBar.vue": [
		469,
		105
	],
	"./components/ProgressTracker.vue": [
		470,
		95
	],
	"./components/Quill.vue": [
		471,
		99
	],
	"./components/Rating.vue": [
		472,
		94
	],
	"./components/Setting.vue": [
		137
	],
	"./components/Slider.vue": [
		473,
		104
	],
	"./components/Switch.vue": [
		474,
		103
	],
	"./components/Tabs.vue": [
		475,
		59
	],
	"./components/Tooltip.vue": [
		476,
		123
	],
	"./components/index.vue": [
		477,
		141
	],
	"./components/modals/CardModal.vue": [
		426,
		93
	],
	"./components/modals/ImageModal.vue": [
		427,
		97
	],
	"./components/modals/Modal.vue": [
		428,
		96
	],
	"./connectorInfo/ConnectorList.vue": [
		478,
		18
	],
	"./connectorInfo/index.vue": [
		479,
		136
	],
	"./connectorInfo/modals/ConnectorStateAddModal.vue": [
		429,
		92
	],
	"./connectorInfo/modals/ConnectorStateEditModal.vue": [
		430,
		91
	],
	"./connectorInfo/modals/ConnectorStateHistoryModal.vue": [
		431,
		90
	],
	"./connectorInfo/modals/DeleteConfirmModal.vue": [
		432,
		122
	],
	"./dashboard/index.vue": [
		480,
		4
	],
	"./echo/Count.vue": [
		481,
		121
	],
	"./echo/index.vue": [
		482,
		135
	],
	"./homeiotdashboard/dashboardCE.vue": [
		483,
		55
	],
	"./homeiotdashboard/dashboardMKT.vue": [
		484,
		54
	],
	"./homeiotdashboard/detailModal.vue": [
		402,
		62
	],
	"./homeiotdashboard/index.vue": [
		485,
		134
	],
	"./homenet/Bill.vue": [
		486,
		8
	],
	"./homenet/BrandInfo.vue": [
		487,
		120
	],
	"./homenet/CctvList.vue": [
		488,
		38
	],
	"./homenet/CentralPage.vue": [
		489,
		0
	],
	"./homenet/ContactList.vue": [
		490,
		37
	],
	"./homenet/DeviceCallbackList.vue": [
		491,
		48
	],
	"./homenet/DeviceList.vue": [
		492,
		1
	],
	"./homenet/DeviceQuery.vue": [
		493,
		2
	],
	"./homenet/EMS.vue": [
		494,
		11
	],
	"./homenet/EVCharge.vue": [
		495,
		30
	],
	"./homenet/ElevatorList.vue": [
		496,
		21
	],
	"./homenet/LegalInfo.vue": [
		497,
		40
	],
	"./homenet/LinkedServiceList.vue": [
		498,
		36
	],
	"./homenet/NotiLatest.vue": [
		499,
		133
	],
	"./homenet/NotiList.vue": [
		500,
		28
	],
	"./homenet/NotificationRequestList.vue": [
		501,
		19
	],
	"./homenet/ParcelInfo.vue": [
		502,
		32
	],
	"./homenet/ParkingAdmin.vue": [
		503,
		39
	],
	"./homenet/ParkingInfo.vue": [
		504,
		132
	],
	"./homenet/PushNotification.vue": [
		505,
		109
	],
	"./homenet/ServiceInfo.vue": [
		506,
		102
	],
	"./homenet/UserInfo.vue": [
		507,
		131
	],
	"./homenet/VisitorHistory.vue": [
		508,
		29
	],
	"./homenet/VisitorVehicle.vue": [
		509,
		24
	],
	"./homenet/VoteInfo.vue": [
		510,
		26
	],
	"./homenet/index.vue": [
		511,
		130
	],
	"./homenet/modals/BillAddModal.vue": [
		388,
		15
	],
	"./homenet/modals/CarAddModal.vue": [
		389,
		89
	],
	"./homenet/modals/CctvAddModal.vue": [
		390,
		88
	],
	"./homenet/modals/ContactAddModal.vue": [
		391,
		87
	],
	"./homenet/modals/DeleteConfirmModal.vue": [
		382,
		119
	],
	"./homenet/modals/DeviceAddModal.vue": [
		384,
		86
	],
	"./homenet/modals/DeviceCallbackAddModal.vue": [
		403,
		85
	],
	"./homenet/modals/DeviceDeleteConfirmModal.vue": [
		383,
		118
	],
	"./homenet/modals/DevicePromptModal.vue": [
		385,
		117
	],
	"./homenet/modals/EMSAddModal.vue": [
		392,
		16
	],
	"./homenet/modals/EVChargeAddModal.vue": [
		404,
		84
	],
	"./homenet/modals/ElevatorAddModal.vue": [
		393,
		83
	],
	"./homenet/modals/EnergyMeterDateControlModal.vue": [
		386,
		14
	],
	"./homenet/modals/EnergyMeterGetDetailModal.vue": [
		387,
		13
	],
	"./homenet/modals/LegalInfoAddModal.vue": [
		405,
		82
	],
	"./homenet/modals/LegalInfoUpdateModal.vue": [
		406,
		81
	],
	"./homenet/modals/LinkedServiceAddModal.vue": [
		407,
		80
	],
	"./homenet/modals/NotiAddModal.vue": [
		394,
		79
	],
	"./homenet/modals/NotiDetailModal.vue": [
		395,
		78
	],
	"./homenet/modals/NotificationRequestAddModal.vue": [
		396,
		77
	],
	"./homenet/modals/ParcelAddModal.vue": [
		397,
		76
	],
	"./homenet/modals/ParkingLotAddModal.vue": [
		398,
		75
	],
	"./homenet/modals/STDeviceControlModal.vue": [
		433,
		116
	],
	"./homenet/modals/VisitorAddModal.vue": [
		399,
		57
	],
	"./homenet/modals/VisitorTotalTimeEditModal.vue": [
		408,
		74
	],
	"./homenet/modals/VisitorVehicleAddModal.vue": [
		409,
		56
	],
	"./homenet/modals/VisitorVehicleEditModal.vue": [
		410,
		73
	],
	"./homenet/modals/VoteAddModal.vue": [
		400,
		53
	],
	"./homenet/share/BillComponent.vue": [
		411,
		10
	],
	"./homenet/share/CctvComponent.vue": [
		412,
		44
	],
	"./homenet/share/ContactComponent.vue": [
		413,
		43
	],
	"./homenet/share/DeviceCallback.vue": [
		434,
		51
	],
	"./homenet/share/DeviceListComponent.vue": [
		401,
		3
	],
	"./homenet/share/EMSComponent.vue": [
		414,
		12
	],
	"./homenet/share/EVChargeComponent.vue": [
		435,
		35
	],
	"./homenet/share/ElevatorComponent.vue": [
		415,
		22
	],
	"./homenet/share/LegalInfoComponent.vue": [
		436,
		46
	],
	"./homenet/share/LinkedServiceComponent.vue": [
		437,
		42
	],
	"./homenet/share/NotiComponent.vue": [
		416,
		31
	],
	"./homenet/share/NotificationRequestComponent.vue": [
		417,
		20
	],
	"./homenet/share/ParcelComponent.vue": [
		418,
		41
	],
	"./homenet/share/ParkingAdminComponent.vue": [
		419,
		47
	],
	"./homenet/share/PushNotificationComponent.vue": [
		420,
		115
	],
	"./homenet/share/Resident.vue": [
		66
	],
	"./homenet/share/ServiceInfoComponent.vue": [
		421,
		114
	],
	"./homenet/share/VisitorHistoryComponent.vue": [
		422,
		33
	],
	"./homenet/share/VisitorVehicleComponent.vue": [
		438,
		25
	],
	"./homenet/share/VoteInfoComponent.vue": [
		423,
		27
	],
	"./house/ComplexList.vue": [
		512,
		23
	],
	"./house/MyPartner.vue": [
		513,
		34
	],
	"./house/PartnerList.vue": [
		514,
		9
	],
	"./house/index.vue": [
		515,
		129
	],
	"./house/modals/BuildingAddModal.vue": [
		439,
		72
	],
	"./house/modals/ComplexCreateModal.vue": [
		440,
		71
	],
	"./house/modals/ComplexEditModal.vue": [
		441,
		70
	],
	"./house/modals/DeleteConfirmModal.vue": [
		424,
		113
	],
	"./house/modals/HouseAddModal.vue": [
		442,
		69
	],
	"./house/modals/PartnerAddDeveloperModal.vue": [
		443,
		68
	],
	"./house/modals/PartnerAddModal.vue": [
		444,
		17
	],
	"./house/modals/PartnerDetailModal.vue": [
		445,
		60
	],
	"./house/modals/ResidentAddModal.vue": [
		446,
		67
	],
	"./nexia/DeviceList.vue": [
		516,
		45
	],
	"./nexia/WebhookList.vue": [
		517,
		50
	],
	"./nexia/index.vue": [
		518,
		128
	],
	"./nexia/modals/DeleteConfirmModal.vue": [
		425,
		112
	],
	"./nexia/modals/DeviceAddModal.vue": [
		447,
		66
	],
	"./nexia/modals/DeviceDetailModal.vue": [
		448,
		65
	],
	"./nexia/modals/WebhookAddModal.vue": [
		449,
		64
	],
	"./tables/Basic.vue": [
		519,
		125
	],
	"./ui/Buttons.vue": [
		520,
		111
	],
	"./ui/Form.vue": [
		521,
		63
	],
	"./ui/Icons.vue": [
		522,
		101
	],
	"./ui/Typography.vue": [
		523,
		127
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 141;

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FooterBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar___default.a; });









/***/ }),
/* 171 */
/***/ (function(module, exports) {



/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  mode: 'history', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    name: 'Home',
    path: '/',
    component: __webpack_require__(135)
  }, {
    name: 'Settings',
    path: '/setting',
    component: __webpack_require__(137)
  }, {
    path: '/auth/personal-token',
    meta: {
      auth: {
        roles: ['user'],
        redirect: { name: 'Home' // ,
          //          forbiddenRedirect: {path: '/'}
        } }
    },
    component: __webpack_require__(136)
  }].concat(_toConsumableArray(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    path: '*',
    redirect: '/'
  }])
});

// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.group !== undefined;
  })) {
    var routeGroups = to.meta.group;
    var groups = null;
    try {
      var decodedToken = __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default.a.decode(window.localStorage['access_token']); // must be same as in app.js
      groups = decodedToken['cognito:groups'];
    } catch (e) {}

    if (groups) {
      var hasPermission = false;
      if (routeGroups) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = routeGroups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var routeGroup = _step.value;

            if (groups.includes(routeGroup)) {
              hasPermission = true;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        hasPermission = true;
      }
      if (hasPermission) {
        next();
      } else {
        console.log('No permission for this group');
        next({ path: '/' });
      }
    } else {
      console.log('Group (cognito-groups) does not exist. No permissions');
      next({ path: '/' });
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(31);


var toggleSidebar = function toggleSidebar(_ref, config) {
  var commit = _ref.commit;

  if (config instanceof Object) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], config);
  }
};

var toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], device);
};

var expandMenu = function expandMenu(_ref3, menuItem) {
  var commit = _ref3.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref4, effectItem) {
  var commit = _ref4.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], effectItem);
  }
};

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pkg", function() { return pkg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componententry", function() { return componententry; });
var pkg = function pkg(state) {
  return state.pkg;
};
var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};



/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_app__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_menu__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_api__ = __webpack_require__(176);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_5__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_6__modules_menu__["a" /* default */],
    api: __WEBPACK_IMPORTED_MODULE_7__modules_api__["a" /* default */]
  },
  state: {
    pkg: __WEBPACK_IMPORTED_MODULE_2_package___default.a
  },
  mutations: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  personaltoken: '/common/auth/personaltoken/',
  logout: '/common/auth/logout',
  echo: '/common/echo',
  echocount: '/common/echo/count',
  sseserver: '/common/sseserver',
  homenetNoti: '/homenet/notice',
  homenetNotiTitle: '/homenet/notice/title',
  homenetNotiMessage: '/homenet/notice/message',
  homenetNotiLatest: '/homenet/notice/latest',
  homenetuser: '/common/users',
  homenetDevice: '/homenet/device',
  homenetDeviceStatus: '/homenet/device/status',
  homenetDeviceControl: '/homenet/device/control',
  homenetCallback: '/homenet/callback',
  homenetCallbackNoti: '/homenet/callback/noti',
  homenetParking: '/homenet/parking',
  homenetParkingLocation: '/homenet/parking/location',
  homenetParkingInfo: '/homenet/parking/info',
  homenetParkingHistory: '/homenet/parking/innouthistory',
  homenetParkingAvailable: '/homenet/parking/available',
  homenetParkinglot: '/homenet/parking/parkinglot',
  homenetParkingCar: '/homenet/parking/car',
  homenetParkingCarPark: '/homenet/parking/park',
  nexia: '/nexia/external/smart_things',
  nexiaWebhook: '/nexia/webhook',
  homenetParcel: '/homenet/parcel',
  homenetVisitor: '/homenet/visitor',
  homenetVisitorVehicle: '/homenet/visitorvehicle',
  homenetVote: '/homenet/vote',
  homenetContact: '/homenet/contact',
  homenetBill: '/homenet/bill',
  homenetEms: '/homenet/ems',
  homenetPushNoti: '/homenet/notification',
  homenetServiceInfo: '/homenet/serviceInfo',
  homenetElv: '/homenet/elevator',
  homenetElvList: '/homenet/elevator/list',
  homenetElvCall: '/homenet/elevator/call',
  homenetElvSse: '/homenet/elevator/sse',
  homenetElvUp: '/homenet/elevator/up',
  homenetElvDown: '/homenet/elevator/down',
  homenetCctv: '/homenet/cctv',
  homenetComplexDetail: '/homenet/complex/detail',
  homenetUserInfo: '/homenet/userinfo',
  homenetNotificationRequest: '/homenet/notification/request',
  homenetEvcharge: '/homenet/evcharge',
  homenetLegalInfo: '/homenet/legalInformation',
  homenetBrandInfo: '/homenet/brandInfo',
  homenetLinkedService: '/homenet/linkedService',
  residentPartner: '/common/partner',
  residentComplex: '/common/complex',
  resident: '/common/residents',
  residentUser: '/common/user',
  stdevice: '/stdevice/device',
  connectorInfo: '/connector/state'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Bill Statement',
  path: '/homenet/bill',
  redirect: '/homenet/bill/statement',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Statement',
    'path': 'statement',
    'meta': {
      'label': 'Statement'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/Bill')
  }]
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Brand Info',
  path: '/homenet/brandinfo',
  redirect: '/homenet/brandinfo/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Info',
    'path': 'info',
    'meta': {
      'label': 'Info'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/BrandInfo')
  }]
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet CCTV',
  path: '/homenet/cctv',
  redirect: '/homenet/cctv/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'List',
    'path': 'list',
    'meta': {
      'label': 'List'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/CctvList')
  }]
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Central Page',
  path: '/homenet/centralpage',
  redirect: '/homenet/centralpage/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'List',
    'path': 'list',
    'meta': {
      'label': 'List'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/CentralPage')
  }]
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Connector Info',
  path: '/connector',
  redirect: '/connector/info',
  meta: {
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('connectorInfo', true),
  children: [{
    'name': 'Connector Health',
    'path': 'info',
    'meta': {
      'label': 'Connector Health'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('connectorInfo/ConnectorList')
  }]
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Contact',
  path: '/homenet/contact',
  redirect: '/homenet/contact/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'List',
    'path': 'list',
    'meta': {
      'label': 'List'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/ContactList')
  }]
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Device',
  path: '/homenet/device',
  redirect: '/homenet/device/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    name: 'HomeNet Device List',
    path: 'list',
    meta: {
      label: 'Device List'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/DeviceList')
  }, {
    name: 'HomeNet Device Query',
    path: 'querytype',
    meta: {
      label: 'Device Query'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/DeviceQuery')
  }, {
    name: 'HomeNet Device Callback',
    path: 'callback',
    meta: {
      label: 'Device Callback'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/DeviceCallbackList')
  }]
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Echo example',
  path: '/echo',
  redirect: '/echo/count',
  meta: {
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('echo', true),

  children: [{
    name: 'echo example',
    path: 'count',
    meta: {
      label: 'echo count',
      link: 'echo/Count.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('echo/Count')
  }]
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Elevator',
  path: '/homenet/elevator',
  redirect: '/homenet/elevator/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Elevator List',
    'path': 'list',
    'meta': {
      'label': 'List'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/ElevatorList')
  }]
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Energy Management',
  path: '/homenet/ems',
  redirect: '/homenet/ems/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Info',
    'path': 'info',
    'meta': {
      'label': 'Info'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/EMS')
  }]
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet EV Charge',
  path: '/homenet/evcharge',
  redirect: '/homenet/evcharge/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'List',
    'path': 'list',
    'meta': {
      'label': 'List'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/EVCharge')
  }]
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home IoT Dashboard',
  path: '/homeiotdashboard',
  redirect: '/homeiotdashboard/dashboard',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homeiotdashboard', true),
  children: [{
    'name': 'Dashboard for MKT team',
    'path': 'dashboardMKT',
    'meta': {
      'label': 'MKT Team Dashboard'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homeiotdashboard/dashboardMKT')
  }, {
    'name': 'Dashboard for CE Team',
    'path': 'dashboardCE',
    'meta': {
      'label': 'CE Team Dashboard'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homeiotdashboard/dashboardCE')
  }]
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Resident Management',
  path: '/resident',
  redirect: '/resident/apt',
  meta: {
    auth: ['user'],
    group: ['admin', 'homenet-dev'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('house', true),

  children: [{
    name: 'PartnerList',
    path: 'partnerlist',
    meta: {
      label: 'Partner List',
      auth: ['user'],
      group: ['admin'] // check cognito group, only visible for this group
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('house/PartnerList')
  }, {
    name: 'MyPartner',
    path: 'partnerinfo',
    meta: {
      label: 'My Partner Info',
      auth: ['user'],
      group: ['homenet-dev']
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('house/MyPartner')
  }, {
    name: 'ComplexManagement',
    path: 'complex',
    meta: {
      label: 'Complex Management',
      auth: ['user'],
      group: ['homenet-dev']
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('house/ComplexList')
  }]
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Legal Information',
  path: '/homenet/legalinfo',
  redirect: '/homenet/legalinfo/data',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Data',
    'path': 'data',
    'meta': {
      'label': 'Data'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/LegalInfo')
  }]
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Linked Service',
  path: '/homenet/linkedService',
  redirect: '/homenet/linkedService/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Linked Service List',
    'path': 'list',
    'meta': {
      'label': 'List'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/LinkedServiceList')
  }]
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Nexia Device',
  path: '/nexia',
  redirect: '/nexia/device',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false,
    group: ['admin', 'nexia']
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('nexia', true),
  children: [{
    'name': 'Device List',
    'path': 'device',
    'meta': {
      'label': 'Device List',
      group: ['admin', 'nexia']
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('nexia/DeviceList')
  }, {
    'name': 'Webbhook List',
    'path': 'webhook',
    'meta': {
      'label': 'Webhook List',
      group: ['admin', 'nexia']
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('nexia/WebhookList')
  }]
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Notification',
  path: '/homenet/noti',
  redirect: '/homenet/noti/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),

  children: [{
    name: 'Notification List',
    path: 'list',
    meta: {
      label: 'Notification List'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/NotiList')
  }, {
    name: 'Latest Notification',
    path: 'latest',
    meta: {
      label: 'Latest Notification'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/NotiLatest')
  }]
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Notification Request',
  path: '/homenet/notificationrequest',
  redirect: '/homenet/notificationrequest/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'List',
    'path': 'list',
    'meta': {
      'label': 'List'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/NotificationRequestList')
  }]
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Parcel',
  path: '/homenet/parcel',
  redirect: '/homenet/parcel/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Delivery Info',
    'path': 'info',
    'meta': {
      'label': 'Delivery Info'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/ParcelInfo')
  }]
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Parking',
  path: '/homenet/parking',
  redirect: '/homenet/parking/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Parking Info',
    'path': 'info',
    'meta': {
      'label': 'Parking Info'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/ParkingInfo')
  }, {
    'name': 'Parking Management',
    'path': 'admin',
    'meta': {
      'label': 'Parking Management'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/ParkingAdmin')
  }]
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Push Notification',
  path: '/homenet/pushnotification',
  redirect: '/homenet/pushnotification/state',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'pushnotification state',
    'path': 'state',
    'meta': {
      'label': 'state'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/PushNotification')
  }]
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Service List',
  path: '/homenet/servicelist',
  redirect: '/homenet/servicelist/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Available Service List',
    'path': 'list',
    'meta': {
      'label': 'list'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/ServiceInfo')
  }]
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet User Info',
  path: '/homenet/userinfo',
  redirect: '/homenet/userinfo/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Info',
    'path': 'info',
    'meta': {
      'label': 'Info'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/UserInfo')
  }]
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Visitor',
  path: '/homenet/visitor',
  redirect: '/homenet/visitor/history',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'History',
    'path': 'history',
    'meta': {
      'label': 'History'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/VisitorHistory')
  }]
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Visitor Vehicle',
  path: '/homenet/visitorvehicle',
  redirect: '/homenet/visitorvehicle/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'List',
    'path': 'list',
    'meta': {
      'label': 'List'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/VisitorVehicle')
  }]
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNet Vote',
  path: '/homenet/vote',
  redirect: '/homenet/vote/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet', true),
  children: [{
    'name': 'Vote',
    'path': 'info',
    'meta': {
      'label': 'Vote'
    },
    'component': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('homenet/VoteInfo')
  }]
});

/***/ }),
/* 203 */,
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout___ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["a" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["b" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1_components_layout___["c" /* AppMain */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["d" /* FooterBar */],
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default.a
  },

  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar({
          opened: !isMobile
        });
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }),

  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['toggleDevice', 'toggleSidebar'])
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Levelbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }), {
    hiddenSidebarStyle: function hiddenSidebarStyle() {
      return this.sidebar.hidden ? { 'margin-left': 0 } : null;
    }
  }),

  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_0__Levelbar___default.a
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__ = __webpack_require__(40);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__["a" /* default */]
  },

  data: function data() {
    var pkg = this.$store.state.pkg;
    var baseUrl = window.location.origin;
    pkg.deviceUrl = baseUrl + '/api/v4/docs/device/';
    // if (this.$auth.check()) {
    pkg.residentUrl = baseUrl + '/api/v4/docs/resident/?access_token=' + this.$auth.token();
    // }
    pkg.cvnetUrl = baseUrl + '/api/v2/docs/cvnet/';
    return this.$store.state.pkg;
  },


  methods: {
    isGroupMember: function isGroupMember(groupname) {
      if (this.$auth.check()) {
        for (var i = 0; i < this.$auth.watch.data['cognito:groups'].length; i++) {
          if (this.$auth.watch.data['cognito:groups'][i] === groupname) return true;
        }

        return false;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__ = __webpack_require__(40);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__["a" /* default */]
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    this.getList();
  },


  computed: {
    codelink: function codelink() {
      if (this.$route.meta && this.$route.meta.link) {
        return 'https://github.sec.samsung.net/Home-IoT/ref-cloud-apiserver/blob/master/frontend/client/views/' + this.$route.meta.link;
      } else {
        return null;
      }
    },
    name: function name() {
      return this.$route.name;
    }
  },

  methods: {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched);
      }
      this.list = matched;
    }
  },

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Tooltip: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__["a" /* default */]
  },
  props: {
    show: Boolean
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    pkginfo: 'pkg',
    sidebar: 'sidebar'
  }),
  data: function data() {
    return {
      stage: '',
      context: 'oauth2 context',
      code: this.$route.query.code,
      type: 'facebook',
      data: {
        rememberMe: 'false'
      },
      isAdmin: false,
      isDev: false,
      btnClass: 'button'
    };
  },
  mounted: function mounted() {
    //    this.configure()
    if (this.code) {
      // console.log('I have authorization code')
      this.$auth.oauth2({
        code: true,
        provider: this.type,
        makeRequest: true,
        fetchUser: false,
        //        rememberMe: false,
        //        state: false,
        params: {
          code: this.code
          //          state: '12345'
        },
        success: function success(res) {
          this.code = null;
          this.isAdmin = this.isGroupMember('admin');
          this.isDev = this.isGroupMember('homenet-dev');
          if (this.isAdmin) {
            this.btnClass = 'button is-danger';
          } else if (this.isDev) {
            this.btnClass = 'button is-warning';
          } else {
            this.btnClass = 'button is-primary';
          }
        },
        error: function error(res) {
          console.log('error ' + this.context);
        }
      });
    } else {
      this.isAdmin = this.isGroupMember('admin');
      this.isDev = this.isGroupMember('homenet-dev');
      if (this.isAdmin) {
        this.btnClass = 'button is-danger';
      } else if (this.isDev) {
        this.btnClass = 'button is-warning';
      } else {
        this.btnClass = 'button is-primary';
      }
    }
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['toggleSidebar']), {
    username: function username() {
      if (this.$auth.check()) {
        return this.$auth.watch.data.username;
      } else {
        return null;
      }
    },
    role: function role() {
      if (this.$auth.check()) {
        return this.$auth.watch.data.role;
      } else {
        return null;
      }
    },
    isGroupMember: function isGroupMember(groupname) {
      if (this.$auth.check()) {
        for (var i = 0; i < this.$auth.watch.data['cognito:groups'].length; i++) {
          if (this.$auth.watch.data['cognito:groups'][i] === groupname) return true;
        }

        return false;
      } else {
        return false;
      }
    },
    logout: function logout() {
      var _this = this;

      this.$http.get(this.$store.state.api.logout).then(function (response) {
        console.log('logged out');
      }).then(function () {
        _this.$auth.logout({
          redirect: { name: 'Home' },
          makeRequest: false
          // params: {},
          // success: function () {},
          // error: function () {},
          // etc...
        });
      }).then(function () {
        console.log('auth logged out');
        var baseUrl = 'https://homeiottf-dev.auth.ap-northeast-2.amazoncognito.com';
        var clientId = 'lfms21abk334e3i1lnkpr70ep';
        var callbackUrl = 'https://www.homeiottf.com';
        var logoutUrl = baseUrl + '/logout?client_id=' + clientId + '&logout_uri=' + callbackUrl;
        window.location.href = logoutUrl;
      }).catch(function (error) {
        _this.$auth.logout({
          redirect: { name: 'Home' },
          makeRequest: false
          // params: {},
          // success: function () {},
          // error: function () {},
          // etc...
        });
        console.log('auth error:', error);
      });
    },
    login: function login(type) {
      // need to check type is null or not
      // console.log('I need code')
      this.$auth.oauth2({
        provider: type || this.type,
        success: function success(res) {
          console.log('Auth Success');
        },
        error: function error(err) {
          if (err.response) {
            // The request was made, but the server responded with a status code
            // that falls out of the range of 2xx
            this.error = err.response.data;
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message);
          }
          console.log(err.config);
        }
      });
    }
  })
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default.a
  },

  props: {
    show: Boolean
  },

  data: function data() {
    return {
      isReady: false
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    menu: 'menuitems'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['expandMenu']), {
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    isVisible: function isVisible(item) {
      if (item.meta.auth === undefined) {
        return true;
      }

      var role = null;
      if (this.$auth.watch.data !== null) {
        role = this.$auth.watch.data[this.$auth.options.rolesVar];
      }

      // if item.meta.auth is false
      // return true if this.$auth is null
      if (item.meta.auth === false) {
        if (role) {
          return false;
        } else {
          return true;
        }
      }

      // if item.meta.auth is true
      // return true if this.$auth is not null
      if (item.meta.auth === true) {
        if (role) {
          return true;
        } else {
          return false;
        }
      }

      // if item.meta.auth is list
      // return true if item.meta.auth include role
      if (Array.isArray(item.meta.auth)) {
        if (role) {
          if (item.meta.auth.includes(role)) {
            if (item.meta.group) {
              var groups = null;
              if (this.$auth.watch.data !== null) {
                groups = this.$auth.watch.data['cognito:groups'];
              }
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = item.meta.group[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var metaGroup = _step.value;

                  if (groups.includes(metaGroup)) {
                    return true;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      try {
        var matched = route.matched;
        var lastMatched = matched[matched.length - 1];
        var parent = lastMatched.parent || lastMatched;
        var isParent = parent === lastMatched;

        if (isParent) {
          var p = this.findParentFromMenu(route);
          if (p) {
            parent = p;
          }
        }

        if ('expanded' in parent.meta && !isParent) {
          this.expandMenu({
            item: parent,
            expanded: true
          });
        }
      } catch (err) {}
    },
    generatePath: function generatePath(item, subItem) {
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  }

});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__homenet_share_Resident__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__homenet_share_Resident___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__homenet_share_Resident__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__homenet_lib_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__homenet_lib_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__homenet_lib_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var RESIDENT_LEVEL = {
  PARTNER: 'partner',
  COMPLEX: 'complex',
  BUILDING: 'building',
  HOUSE: 'house',
  USER: 'user'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Resident: __WEBPACK_IMPORTED_MODULE_0__homenet_share_Resident___default.a
  },

  data: function data() {
    return {
      isAdmin: false,
      isHomenetDev: false,
      pkg: this.$store.state.pkg,
      userVisible: true,
      getServerData: true,
      RESIDENT_LEVEL: RESIDENT_LEVEL
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.isAdmin = __WEBPACK_IMPORTED_MODULE_1__homenet_lib_utils___default.a.isGroupMember(this, 'admin');
    this.isHomenetDev = __WEBPACK_IMPORTED_MODULE_1__homenet_lib_utils___default.a.isGroupMember(this, 'homenet-dev');
    if (!this.isAdmin && !this.isHomenetDev) {
      window.addEventListener('auth-token-localstorage-changed', function () {
        _this.isHomenetDev = __WEBPACK_IMPORTED_MODULE_1__homenet_lib_utils___default.a.isGroupMember(_this, 'homenet-dev');
        _this.isAdmin = __WEBPACK_IMPORTED_MODULE_1__homenet_lib_utils___default.a.isGroupMember(_this, 'admin');
      });
    }
  },


  methods: {
    storeResident: function storeResident(residentLevel) {
      var username = '';
      if (this.$auth.watch && this.$auth.watch.data && this.$auth.watch.data.username) {
        username = this.$auth.watch.data.username + '-';
      }
      var resident = this.$refs.residentRef;
      if (residentLevel === RESIDENT_LEVEL.PARTNER) {
        console.log('Partner changed');
        window.localStorage.setItem(username + 'partnerList', resident.partnerList);
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner);
      } else if (residentLevel === RESIDENT_LEVEL.COMPLEX) {
        console.log('Complex changed');
        window.localStorage.setItem(username + 'partnerList', resident.partnerList);
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner);
        window.localStorage.setItem(username + 'complexList', resident.complexList);
        window.localStorage.setItem(username + 'selectedComplex', resident.selectedComplex);
      } else if (residentLevel === RESIDENT_LEVEL.BUILDING) {
        console.log('Building changed');
        window.localStorage.setItem(username + 'partnerList', resident.partnerList);
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner);
        window.localStorage.setItem(username + 'complexList', resident.complexList);
        window.localStorage.setItem(username + 'selectedComplex', resident.selectedComplex);
        window.localStorage.setItem(username + 'buildingList', JSON.stringify(resident.buildingList, null, 2));
        window.localStorage.setItem(username + 'selectedBuilding', JSON.stringify(resident.selectedBuilding, null, 2));
      } else if (residentLevel === RESIDENT_LEVEL.HOUSE) {
        console.log('House changed');
        window.localStorage.setItem(username + 'partnerList', resident.partnerList);
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner);
        window.localStorage.setItem(username + 'complexList', resident.complexList);
        window.localStorage.setItem(username + 'selectedComplex', resident.selectedComplex);
        window.localStorage.setItem(username + 'buildingList', JSON.stringify(resident.buildingList, null, 2));
        window.localStorage.setItem(username + 'selectedBuilding', JSON.stringify(resident.selectedBuilding, null, 2));
        window.localStorage.setItem(username + 'houseList', JSON.stringify(resident.houseList, null, 2));
        window.localStorage.setItem(username + 'selectedHouse', JSON.stringify(resident.selectedHouse, null, 2));
      } else if (residentLevel === RESIDENT_LEVEL.USER) {
        console.log('User changed');
        window.localStorage.setItem(username + 'partnerList', resident.partnerList);
        window.localStorage.setItem(username + 'selectedPartner', resident.selectedPartner);
        window.localStorage.setItem(username + 'complexList', resident.complexList);
        window.localStorage.setItem(username + 'selectedComplex', resident.selectedComplex);
        window.localStorage.setItem(username + 'buildingList', JSON.stringify(resident.buildingList, null, 2));
        window.localStorage.setItem(username + 'selectedBuilding', JSON.stringify(resident.selectedBuilding, null, 2));
        window.localStorage.setItem(username + 'houseList', JSON.stringify(resident.houseList, null, 2));
        window.localStorage.setItem(username + 'selectedHouse', JSON.stringify(resident.selectedHouse, null, 2));
        window.localStorage.setItem(username + 'userList', resident.userList);
        window.localStorage.setItem(username + 'selectedUser', resident.selectedUser);
      }
    }
  }

});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      token: '',
      tokenstatus: -1
    };
  },

  methods: {
    generatepersonaltoken: function generatepersonaltoken() {
      var _this = this;

      this.$http.post(this.$store.state.api.personaltoken).then(function (response) {
        if (response.status === 200) {
          _this.token = response.data;
          // document.getElementById('token').value = response.data
          _this.tokenstatus = 99;
        }
      }).catch(function (error) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_util___default.a.inspect(error));
      });
    },
    revokepersonaltoken: function revokepersonaltoken() {
      var _this2 = this;

      this.$http.delete(this.$store.state.api.personaltoken).then(function (response) {
        // document.getElementById('token').value = 'Click Generate button for the new token'
        _this2.token = 'Click Generate button for the new token';
        _this2.tokenstatus = 0;
      }).catch(function (error) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_util___default.a.inspect(error));
      });
    },
    clipboard: function clipboard() {
      var token = document.getElementById('token');
      token.select();
      document.execCommand('copy');
      this.tokenstatus = 1;
      // document.getElementById('token').value = 'YOU HAVE A PERSONAL TOKEN'
      this.token = 'YOU HAVE A PERSONAL TOKEN';
    },
    checkStatus: function checkStatus() {
      return this.tokenstatus;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$http.get(this.$store.state.api.personaltoken).then(function (response) {
      if (response.status === 200) {
        // document.getElementById('token').value = 'YOU HAVE A PERSONAL TOKEN'
        _this3.token = 'YOU HAVE A PERSONAL TOKEN';
        _this3.tokenstatus = 1;
      }
    }).catch(function (error) {
      if (error.response.status === 400) {
        // document.getElementById('token').value = error.response.statusText
        _this3.token = error.response.statusText;
        _this3.tokenstatus = -2;
      } else if (error.response.status === 404) {
        // document.getElementById('token').value = 'Click Generate button for the new token'
        _this3.token = 'Click Generate button for the new token';
        _this3.tokenstatus = 0;
      }
    });
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_jump__ = __webpack_require__(140);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BackToTop: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_jump__["a" /* BackToTop */]
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lib_utils__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var config = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    topDivClass: {
      type: String,
      default: 'box'
    },
    complexVisible: {
      type: Boolean,
      default: true
    },
    buildingVisible: {
      type: Boolean,
      default: true
    },
    houseVisible: {
      type: Boolean,
      default: true
    },
    userVisible: {
      type: Boolean,
      default: false
    },
    getServerData: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      isAdmin: false,
      isHomenetDev: false,
      partnerList: [],
      selectedPartner: null,
      complexList: [],
      selectedComplex: null,
      buildingList: [],
      selectedBuilding: null,
      houseList: [],
      selectedHouse: null,
      userList: [],
      selectedUser: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.isAdmin = __WEBPACK_IMPORTED_MODULE_2__lib_utils___default.a.isGroupMember(this, 'admin');
    this.isHomenetDev = __WEBPACK_IMPORTED_MODULE_2__lib_utils___default.a.isGroupMember(this, 'homenet-dev');
    if (this.getServerData) {
      if (this.isAdmin) {
        this.getPartnerList();
      } else if (this.isHomenetDev) {
        this.getMyPartner();
      } else {
        window.addEventListener('auth-token-localstorage-changed', function (event) {
          console.log('Auth token on local storage got changed');
          _this.isHomenetDev = __WEBPACK_IMPORTED_MODULE_2__lib_utils___default.a.isGroupMember(_this, 'homenet-dev');
          _this.isAdmin = __WEBPACK_IMPORTED_MODULE_2__lib_utils___default.a.isGroupMember(_this, 'admin');
          if (_this.isAdmin) {
            _this.getPartnerList();
          } else if (_this.isHomenetDev) {
            _this.getMyPartner();
          }
        });
      }
    } else {
      this.$nextTick(function () {
        _this.getLocalData();
      });
    }
  },


  methods: {
    getLocalData: function getLocalData() {
      console.log('get local data');
      var username = '';
      if (this.$auth.watch && this.$auth.watch.data && this.$auth.watch.data.username) {
        username = this.$auth.watch.data.username + '-';
      }
      var localPartnerList = window.localStorage.getItem(username + 'partnerList');
      if (localPartnerList) {
        this.partnerList = localPartnerList.split(',');
      } else {
        this.partnerList = [];
      }
      this.selectedPartner = window.localStorage.getItem(username + 'selectedPartner');
      this.$emit('partnerChanged');

      var localComplexList = window.localStorage.getItem(username + 'complexList');
      if (localComplexList) {
        this.complexList = localComplexList.split(',');
      } else {
        this.complexList = [];
      }
      this.selectedComplex = window.localStorage.getItem(username + 'selectedComplex');
      this.$emit('complexChanged');

      var localBuildingList = window.localStorage.getItem(username + 'buildingList');
      if (localPartnerList) {
        this.buildingList = JSON.parse(localBuildingList);
      } else {
        this.buildingList = [];
      }
      this.selectedBuilding = JSON.parse(window.localStorage.getItem(username + 'selectedBuilding'));
      this.$emit('buildingChanged');

      var localHouseList = window.localStorage.getItem(username + 'houseList');
      if (localHouseList) {
        this.houseList = JSON.parse(localHouseList);
      } else {
        this.houseList = [];
      }
      this.selectedHouse = JSON.parse(window.localStorage.getItem(username + 'selectedHouse'));
      this.$emit('houseChanged');

      this.userList = window.localStorage.getItem(username + 'userList');
      this.selectedUser = window.localStorage.getItem(username + 'selectedUser');
      this.$emit('userChanged');
    },
    getSelectedItem: function getSelectedItem(array, localKey, compareKey) {
      if (!array || array.length === 0) {
        return null;
      }
      var username = '';
      if (this.$auth.watch && this.$auth.watch.data && this.$auth.watch.data.username) {
        username = this.$auth.watch.data.username + '-';
      }
      var localData = window.localStorage.getItem(username + localKey);
      if (!localData) {
        return array[0];
      }
      try {
        var parsedData = JSON.parse(localData);
        localData = parsedData;
      } catch (err) {}
      if (array.indexOf(localData) >= 0) {
        return localData;
      }
      if (compareKey) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item[compareKey] === localData[compareKey]) {
              return item;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return array[0];
    },
    getPartnerList: function getPartnerList() {
      var _this2 = this;

      this.partnerList = [];
      this.selectedPartner = null;
      this.complexList = [];
      this.selectedComplex = null;
      this.buildingList = [];
      this.selectedBuilding = null;
      this.houseList = [];
      this.selectedHouse = null;
      this.userList = [];
      this.selectedUser = null;
      var url = this.$store.state.api.residentPartner;
      console.log('partner list url: ' + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.defaults.baseURL + url);
      this.$http.get(url, config).then(function (response) {
        if (response.data) {
          response.data.forEach(function (partner) {
            _this2.partnerList.push(partner.name);
          });
        }
        console.log('get partner data: ', __WEBPACK_IMPORTED_MODULE_2__lib_utils___default.a.jsonpretty(response.data));
        if (_this2.partnerList.length > 0) {
          _this2.selectedPartner = _this2.getSelectedItem(_this2.partnerList, 'selectedPartner');
        }
        if (_this2.selectedPartner) {
          _this2.$emit('partnerChanged');
          _this2.getComplexList();
        }
      }).catch(function (error) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_util___default.a.inspect(error));
      });
    },
    getMyPartner: function getMyPartner() {
      var _this3 = this;

      this.partnerList = [];
      this.selectedPartner = null;
      this.complexList = [];
      this.selectedComplex = null;
      this.buildingList = [];
      this.selectedBuilding = null;
      this.houseList = [];
      this.selectedHouse = null;
      this.userList = [];
      this.selectedUser = null;
      var url = this.$store.state.api.residentPartner + '/my';
      console.log('my parter url: ' + __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.defaults.baseURL + url);
      this.$http.get(url, config).then(function (response) {
        if (response.data) {
          response.data.forEach(function (partner) {
            _this3.partnerList.push(partner.name);
          });
        }
        console.log('get partner data: ', __WEBPACK_IMPORTED_MODULE_2__lib_utils___default.a.jsonpretty(response.data));
        if (_this3.partnerList.length > 0) {
          _this3.selectedPartner = _this3.getSelectedItem(_this3.partnerList, 'selectedPartner');
          _this3.$emit('partnerChanged');
        }
        if (_this3.selectedPartner) _this3.getComplexList();
      }).catch(function (error) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_util___default.a.inspect(error));
      });
    },
    partnerChanged: function partnerChanged() {
      this.$emit('partnerChanged');
      this.getComplexList();
    },
    getComplexList: function getComplexList() {
      var _this4 = this;

      this.complexList = [];
      this.selectedComplex = null;
      this.buildingList = [];
      this.selectedBuilding = null;
      this.houseList = [];
      this.selectedHouse = null;
      this.userList = [];
      this.selectedUser = null;
      var url = this.$store.state.api.residentComplex + '/' + this.selectedPartner;
      this.$http.get(url, config).then(function (response) {
        if (response.data) {
          _this4.complexList = response.data;
        }
        if (_this4.complexList && _this4.complexList.length > 0) {
          _this4.selectedComplex = _this4.getSelectedItem(_this4.complexList, 'selectedComplex');
          _this4.$emit('complexChanged');
          _this4.getComplexDetail();
        }
      }).catch(function (error) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_util___default.a.inspect(error));
      });
    },
    getComplexDetail: function getComplexDetail() {
      var _this5 = this;

      this.buildingList = [];
      this.selectedBuilding = null;
      this.houseList = [];
      this.selectedHouse = null;
      this.userList = [];
      this.selectedUser = null;
      var url = this.$store.state.api.residentComplex + '/' + this.selectedPartner + '/' + this.selectedComplex;
      this.$http.get(url, config).then(function (response) {
        if (response.data) {
          console.log('get complex detail:', __WEBPACK_IMPORTED_MODULE_2__lib_utils___default.a.jsonpretty(response.data));
          var buildingChangedEmit = false;
          var houseChangedEmit = false;
          var userChangedEmit = false;
          response.data.buildings.forEach(function (bld) {
            _this5.buildingList.push(bld);
          });
          _this5.selectedBuilding = _this5.getSelectedItem(_this5.buildingList, 'selectedBuilding', 'name');
          if (_this5.selectedBuilding) {
            buildingChangedEmit = true;
            _this5.selectedBuilding.houses.forEach(function (house) {
              _this5.houseList.push(house);
            });
            _this5.selectedHouse = _this5.getSelectedItem(_this5.houseList, 'selectedHouse', 'name');
            houseChangedEmit = true;
            if (_this5.selectedHouse) {
              _this5.selectedHouse.residents.forEach(function (user) {
                _this5.userList.push(user.Username);
              });
              _this5.selectedUser = _this5.getSelectedItem(_this5.userList, 'selectedUser');
              userChangedEmit = true;
            }
          }
          if (buildingChangedEmit) {
            _this5.$emit('buildingChanged');
          }
          if (houseChangedEmit) {
            _this5.$emit('houseChanged');
          }
          if (userChangedEmit) {
            _this5.$emit('userChanged');
          }
        }
      }).catch(function (error) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_util___default.a.inspect(error));
      });
    },
    complexChanged: function complexChanged() {
      this.$emit('complexChanged');
      this.getComplexDetail();
    },
    buildingChanged: function buildingChanged() {
      var _this6 = this;

      this.$emit('buildingChanged');
      this.houseList = [];
      this.selectedHouse = null;
      this.userList = [];
      this.selectedUser = null;
      var houseChangedEmit = false;
      var userChangedEmit = false;
      if (this.selectedBuilding) {
        this.selectedBuilding.houses.forEach(function (house) {
          _this6.houseList.push(house);
        });
        this.selectedHouse = this.getSelectedItem(this.houseList, 'selectedHouse', 'name');
        if (this.selectedHouse) {
          this.selectedHouse.residents.forEach(function (user) {
            _this6.userList.push(user.Username);
          });
          if (this.userList.length > 0) {
            this.selectedUser = this.getSelectedItem(this.userList, 'selectedUser');
            userChangedEmit = true;
          }
        }
        if (houseChangedEmit) {
          this.$emit('houseChanged');
        }
        if (userChangedEmit) {
          this.$emit('userChanged');
        }
      }
    },
    houseChanged: function houseChanged() {
      var _this7 = this;

      console.log('House got changed');
      this.$emit('houseChanged');
      this.userList = [];
      this.selectedUser = null;
      if (this.selectedHouse) {
        this.selectedHouse.residents.forEach(function (user) {
          _this7.userList.push(user.Username);
        });
      }
      if (this.userList.length > 0) {
        this.selectedUser = this.getSelectedItem(this.userList, 'selectedUser');
        this.$emit('userChanged');
      }
    },
    userChanged: function userChanged() {
      this.$emit('userChanged');
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(203);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    visibilityHeight: {
      type: Number,
      default: 400
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },


  methods: {
    handleScroll: function handleScroll() {
      this.visible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* getScroll */])(window, true) > this.visibilityHeight;
    },
    scrollToTop: function scrollToTop() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(document.body, this.options);
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(115);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    target: String,
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  created: function created() {
    this.$el = this.$el.nextSibling;
  },
  mounted: function mounted() {
    this.$el.addEventListener('click', this.handler);
  },


  methods: {
    handler: function handler() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(this.target, this.options);
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nprogress-container'
});

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.5.4","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.5.4","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.5.4","saveSpec":null,"fetchSpec":"^6.5.4"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.4.tgz","_shasum":"da37cebd31e79a1367e941b592ed1fbebd58abbb","_spec":"elliptic@^6.5.4","_where":"/workspace/code-runner-metronome-23-default-4/_work/ref-cloud-apiserver/ref-cloud-apiserver/frontend/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nprogress__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex_store_mutation_types__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_popover__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_socket_io__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jsonwebtoken__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jsonwebtoken__);
/* unused harmony reexport router */
/* unused harmony reexport store */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable no-undef */














// import util from 'util'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth___default.a, {
  auth: {
    request: function request(req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
    },
    response: function response(res) {
      // Get Token from response body
      //      return res.headers.token
      console.log(res.data);
      return res.data.access_token;
    }
  },
  http: __webpack_require__(142),
  router: __webpack_require__(143),
  rolesVar: 'role',
  loginData: { fetchUser: false },
  fetchData: { enabled: false },
  refreshData: { enabled: false },
  tokenDefaultName: 'access_token',
  facebookData: {
    url: 'common/auth/oauth2',
    method: 'POST',
    redirect: '/'
  },
  facebookOauth2Data: {
    clientId: 'lfms21abk334e3i1lnkpr70ep',
    response_type: 'code',
    url: 'https://homeiottf-dev.auth.ap-northeast-2.amazoncognito.com/authorize',
    redirect: function redirect() {
      return this.options.getUrl();
    },
    scope: 'openid profile'
  },
  /*
    parseOauthState: function (data) {
      console.log('parseOauthState: ' + data)
    },
  */
  parseUserData: function parseUserData(data) {
    var _this = this;

    console.log('parseUserData: ' + data);
    if (window.localStorage[this.options.tokenDefaultName] !== null) {
      var decodedToken = __WEBPACK_IMPORTED_MODULE_13_jsonwebtoken___default.a.decode(window.localStorage[this.options.tokenDefaultName]);
      decodedToken.role = 'user';
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
        window.dispatchEvent(new CustomEvent('auth-token-localstorage-changed', {
          detail: {
            token: window.localStorage.getItem(_this.options.tokenDefaultName)
          }
        }));
      });
      return decodedToken;
    } else {
      return null;
    }
    /*
        if (window.localStorage[this.options.tokenDefaultName] !== null) {
          var decodedToken = jwt.decode(window.localStorage[this.options.tokenDefaultName])
          if (decodedToken.role === 1) {
            decodedToken.role = 'pm'
          } else if (decodedToken.role === 2) {
            decodedToken.role = 'user'
          } else {
            decodedToken.role = 'unidentified'
          }
          return decodedToken
        } else {
          return null
        }
    */
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/api';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_nprogress___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_js_popover___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_socket_io___default.a, window.location.protocol + '//' + window.location.hostname + ':' + window.location.port);

// Disable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = false;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]);

var state = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state;


var nprogress = new __WEBPACK_IMPORTED_MODULE_4_vue_nprogress___default.a({ parent: '.nprogress-container' });

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].beforeEach(function (route, redirect, next) {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_10_vuex_store_mutation_types__["a" /* TOGGLE_SIDEBAR */], false);
  }
  next();
});

Object.keys(__WEBPACK_IMPORTED_MODULE_9__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_9__filters__[key]);
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](_extends({
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_6__App_vue___default.a));



/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(31);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], function (state, config) {
  if (state.device.isMobile && config.hasOwnProperty('opened')) {
    state.sidebar.opened = config.opened;
  } else {
    state.sidebar.opened = true;
  }

  if (config.hasOwnProperty('hidden')) {
    state.sidebar.hidden = config.hidden;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(272)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(354),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(279)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(363),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(278)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(361),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(362),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(273)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(353),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(276)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(351),
  /* scopeId */
  "data-v-2e98c7ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(274)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(269)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "wysiwyg"
  }, [_c('h1', [_vm._v("Personal access token")]), _vm._v(" "), _c('h4', [_vm._v("Make sure to copy your new personal access token now. You won’t be able to see it again!")]), _vm._v(" "), _c('h4', [_vm._v("If you forgot your personal access token, revoke it and generate again!")]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "control is-fullwidth"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    staticClass: "input",
    attrs: {
      "rows": "4",
      "id": "token",
      "type": "text",
      "placeholder": "Checking your personal token",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "control is-fullwidth"
  }, [(_vm.checkStatus() === 99) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.clipboard()
      }
    }
  }, [_vm._v("Copy to Clipboard")]) : _vm._e(), _vm._v(" "), (_vm.checkStatus() === 0) ? _c('button', {
    staticClass: "button is-normal",
    on: {
      "click": function($event) {
        _vm.generatepersonaltoken()
      }
    }
  }, [_vm._v("Generate")]) : _vm._e(), _vm._v(" "), (_vm.checkStatus() === 1) ? _c('button', {
    staticClass: "button is-danger",
    on: {
      "click": function($event) {
        _vm.revokepersonaltoken()
      }
    }
  }, [_vm._v("Revoke")]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Personal access token")])])
}]}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jump"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show,
      slideOutLeft: !_vm.show
    }
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return (_vm.isVisible(item)) ? _c('li', [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path && _vm.isVisible(subItem)) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_vm._v("\n              " + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n            ")])], 1) : _vm._e()
    }))]) : _vm._e()], 1) : _vm._e()
  }))])
},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show,
      slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(333),
      "alt": _vm.pkginfo.description
    }
  }), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": 'v' + _vm.pkginfo.version,
      "placement": "right",
      "type": "success",
      "size": "small",
      "no-animate": true,
      "always": true,
      "rounded": true
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v("Home IoT")]), _c('strong', {
    staticClass: "admin"
  }, [_vm._v(" Reference Server " + _vm._s(_vm.stage))])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [(!_vm.$auth.check()) ? _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.login('facebook')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Login with OAuth2")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:user",
      arg: "user"
    }],
    class: _vm.btnClass
  }, [_vm._v("Welcome " + _vm._s(_vm.username()))]) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('popover', {
    attrs: {
      "name": "user"
    }
  }, [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('ul', {
    staticClass: "menu-item"
  }, [(_vm.isAdmin) ? _c('li', [_vm._v("Logged-in as an admin")]) : _vm._e(), _vm._v(" "), (_vm.isDev) ? _c('li', [_vm._v("Logged-in as a Developer")]) : _vm._e(), _vm._v(" "), (!_vm.isAdmin && !_vm.isDev) ? _c('li', [_vm._v("Logged-in as a Resident")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "button button-menu is-danger is-small",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Logout")])])])])]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fab"
  })])
}]}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "wysiwyg"
  }, [_c('h1', [_vm._v("Hello World")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.")]), _vm._v(" "), _c('h2', [_vm._v("Second level")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Third level")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('blockquote', [_vm._v("Ut venenatis, nisl scelerisque sollicitudin fermentum, quam libero hendrerit ipsum, ut blandit est tellus sit amet turpis.")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("Sed sagittis enim ac tortor maximus rutrum. Nulla facilisi. Donec mattis vulputate risus in luctus. Maecenas vestibulum interdum commodo.")]), _vm._v(" "), _c('p', [_vm._v("Suspendisse egestas sapien non felis placerat elementum. Morbi tortor nisl, suscipit sed mi sit amet, mollis malesuada nulla. Nulla facilisi. Nullam ac erat ante.")]), _vm._v(" "), _c('h4', [_vm._v("Fourth level")]), _vm._v(" "), _c('p', [_vm._v("Nulla efficitur eleifend nisi, sit amet bibendum sapien fringilla ac. Mauris euismod metus a tellus laoreet, at elementum ex efficitur.")]), _vm._v(" "), _c('p', [_vm._v("Maecenas eleifend sollicitudin dui, faucibus sollicitudin augue cursus non. Ut finibus eleifend arcu ut vehicula. Mauris eu est maximus est porta condimentum in eu justo. Nulla id iaculis sapien.")]), _vm._v(" "), _c('p', [_vm._v("Phasellus porttitor enim id metus volutpat ultricies. Ut nisi nunc, blandit sed dapibus at, vestibulum in felis. Etiam iaculis lorem ac nibh bibendum rhoncus. Nam interdum efficitur ligula sit amet ullamcorper. Etiam tristique, leo vitae porta faucibus, mi lacus laoreet metus, at cursus leo est vel tellus. Sed ac posuere est. Nunc ultricies nunc neque, vitae ultricies ex sodales quis. Aliquam eu nibh in libero accumsan pulvinar. Nullam nec nisl placerat, pretium metus vel, euismod ipsum. Proin tempor cursus nisl vel condimentum. Nam pharetra varius metus non pellentesque.")]), _vm._v(" "), _c('h5', [_vm._v("Fifth level")]), _vm._v(" "), _c('p', [_vm._v("Aliquam sagittis rhoncus vulputate. Cras non luctus sem, sed tincidunt ligula. Vestibulum at nunc elit. Praesent aliquet ligula mi, in luctus elit volutpat porta. Phasellus molestie diam vel nisi sodales, a eleifend augue laoreet. Sed nec eleifend justo. Nam et sollicitudin odio.")]), _vm._v(" "), _c('h6', [_vm._v("Sixth level")]), _vm._v(" "), _c('p', [_vm._v("Cras in nibh lacinia, venenatis nisi et, auctor urna. Donec pulvinar lacus sed diam dignissim, ut eleifend eros accumsan. Phasellus non tortor eros. Ut sed rutrum lacus. Etiam purus nunc, scelerisque quis enim vitae, malesuada ultrices turpis. Nunc vitae maximus purus, nec consectetur dui. Suspendisse euismod, elit vel rutrum commodo, ipsum tortor maximus dui, sed varius sapien odio vitae est. Etiam at cursus metus.")]), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "target": ".is-child .wysiwyg"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("UP")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Curabitur accumsan turpis pharetra "), _c('strong', [_vm._v("augue tincidunt")]), _vm._v(" blandit. Quisque condimentum maximus mi, sit amet commodo arcu rutrum id. Proin pretium urna vel cursus venenatis. Suspendisse potenti. Etiam mattis sem rhoncus lacus dapibus facilisis. Donec at dignissim dui. Ut et neque nisl.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("In fermentum leo eu lectus mollis, quis dictum mi aliquet.")]), _vm._v(" "), _c('li', [_vm._v("Morbi eu nulla lobortis, lobortis est in, fringilla felis.")]), _vm._v(" "), _c('li', [_vm._v("Aliquam nec felis in sapien venenatis viverra fermentum nec lectus.")]), _vm._v(" "), _c('li', [_vm._v("Ut non enim metus.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Quisque ante lacus, malesuada ac auctor vitae, congue "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("non ante")]), _vm._v(". Phasellus lacus ex, semper ac tortor nec, fringilla condimentum orci. Fusce eu rutrum tellus.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Donec blandit a lorem id convallis.")]), _vm._v(" "), _c('li', [_vm._v("Cras gravida arcu at diam gravida gravida.")]), _vm._v(" "), _c('li', [_vm._v("Integer in volutpat libero.")]), _vm._v(" "), _c('li', [_vm._v("Donec a diam tellus.")]), _vm._v(" "), _c('li', [_vm._v("Aenean nec tortor orci.")]), _vm._v(" "), _c('li', [_vm._v("Quisque aliquam cursus urna, non bibendum massa viverra eget.")]), _vm._v(" "), _c('li', [_vm._v("Vivamus maximus ultricies pulvinar.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Quisque at semper enim, eu hendrerit odio. Etiam auctor nisl et "), _c('em', [_vm._v("justo sodales")]), _vm._v(" elementum. Maecenas ultrices lacus quis neque consectetur, et lobortis nisi molestie.")])
}]}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "jump back-to-top",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "200",
      "src": __webpack_require__(332),
      "alt": _vm.pkg.description
    }
  })]), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev)) ? _c('div', {
    staticClass: "has-text-left label"
  }, [_vm._v("Change the below values to reflect in other service pages:")]) : _vm._e(), _vm._v(" "), _c('Resident', {
    ref: "residentRef",
    attrs: {
      "userVisible": _vm.userVisible,
      "getServerData": _vm.getServerData
    },
    on: {
      "partnerChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.PARTNER)
      },
      "complexChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.COMPLEX)
      },
      "buildingChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.BUILDING)
      },
      "houseChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.HOUSE)
      },
      "userChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.USER)
      }
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v(_vm._s(_vm.pkg.name.replace(/-/gi, ' ')))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.pkg.description))]), _vm._v(",\n    "), _c('a', {
    attrs: {
      "href": _vm.pkg.homepage
    }
  }, [_vm._v("Live Demo")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isAdmin || _vm.isHomenetDev) ? _c('div', {
    staticClass: "residentTop"
  }, [_c('div', {
    class: _vm.topDivClass
  }, [_c('div', {
    staticClass: "columns"
  }, [(_vm.isAdmin) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Partner:")])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPartner),
      expression: "selectedPartner"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPartner = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.partnerChanged]
    }
  }, _vm._l((_vm.partnerList), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }))])]) : _vm._e(), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev) && _vm.complexVisible) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Complex:")])]) : _vm._e(), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev) && _vm.complexVisible) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedComplex),
      expression: "selectedComplex"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedComplex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.complexChanged]
    }
  }, _vm._l((_vm.complexList), function(c) {
    return _c('option', {
      domProps: {
        "value": c
      }
    }, [_vm._v(_vm._s(c))])
  }))])]) : _vm._e(), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev) && _vm.buildingVisible) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Building:")])]) : _vm._e(), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev) && _vm.buildingVisible) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedBuilding),
      expression: "selectedBuilding"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedBuilding = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.buildingChanged]
    }
  }, _vm._l((_vm.buildingList), function(b) {
    return _c('option', {
      domProps: {
        "value": b
      }
    }, [_vm._v(_vm._s(b.name))])
  }))])]) : _vm._e(), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev) && _vm.houseVisible) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("House:")])]) : _vm._e(), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev) && _vm.houseVisible) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedHouse),
      expression: "selectedHouse"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedHouse = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.houseChanged]
    }
  }, _vm._l((_vm.houseList), function(h) {
    return _c('option', {
      domProps: {
        "value": h
      }
    }, [_vm._v(_vm._s(h.name))])
  }))])]) : _vm._e(), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev) && _vm.userVisible) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("User:")])]) : _vm._e(), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev) && _vm.userVisible) ? _c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUser),
      expression: "selectedUser"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.userChanged]
    }
  }, _vm._l((_vm.userList), function(u) {
    return _c('option', {
      domProps: {
        "value": u
      }
    }, [_vm._v(_vm._s(u))])
  }))])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', {
    staticClass: "social"
  }, [_c('tooltip', {
    attrs: {
      "label": "Home IoT TF Github",
      "placement": "top-right"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.repository,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fab fa-github fa-lg"
  })])])]), _vm._v("\n         \n        "), _c('tooltip', {
    attrs: {
      "label": "Home IoT TF Confluence",
      "placement": "top-right"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://suprem.sec.samsung.net/confluence/pages/viewpage.action?pageId=103470995",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "far fa-clipboard fa-lg"
  })])])]), _vm._v("\n         \n        "), (_vm.isGroupMember('admin')) ? _c('tooltip', {
    attrs: {
      "label": "Resident API Document",
      "placement": "top-right"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.residentUrl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "far fa-file-alt fa-lg"
  })])])]) : _vm._e(), _vm._v("\n         \n        "), _c('tooltip', {
    attrs: {
      "label": "Device API Document",
      "placement": "top-right"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.deviceUrl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "far fa-file-alt fa-lg"
  })])])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])])]), _vm._v(" "), (!!_vm.codelink) ? _c('div', {
    staticClass: "level-item"
  }, [_c('tooltip', {
    attrs: {
      "label": "View code",
      "placement": "right",
      "size": "small",
      "rounded": true
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.codelink
    }
  }, [_c('i', {
    staticClass: "fab fa-github"
  })])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    style: ([_vm.hiddenSidebarStyle])
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */
/***/ (function(module, exports) {

module.exports = {"name":"ref-server","version":"2.0.0","description":"HomeIoT Reference Server","repository":"https://github.sec.samsung.net/Home-IoT","homepage":"https://www.homeiottf.com/","license":"MIT","authors":[{"name":"Jongwoo Chae","email":"jongwoo.chae@samsung.com","url":"10.113.177.89"},{"name":"Thiep Ha","email":"thiep.ha@samsung.com"}],"keywords":["admin","bulma","dashboard","data","visualization","vue"],"engines":{"node":">=4","npm":">=3"},"scripts":{"build":"NODE_ENV=production node build/build.js","clean":"rm -rf dist","dev":"cross-env NODE_ENV=development node build/dev-server.js","electron":"cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js","gh":"npm run build && gh-pages -d dist","lint":"eslint --ext .js .vue client/*","lint:fix":"eslint --fix --ext .js .vue electron.js client/* build/* config/*","test":"echo lol"},"dependencies":{"@fortawesome/fontawesome-free":"5.11.0","@websanova/vue-auth":"2.21.14-beta","animate.css":"3.5.2","animejs":"^2.0.1","axios":"0.18.0","bulma":"^0.3.2","chartist":"^0.11.0","chartist-plugin-legend":"^0.6.2","chartist-plugin-tooltips-updated":"^0.0.21","dateformat":"^3.0.3","eventsource-polyfill":"^0.9.6","jsonwebtoken":"8.3.0","mdi":"^1.8.36","original":"^1.0.0","plotly.js":"^1.24.2","vue":"2.5.16","vue-axios":"2.1.1","vue-bulma-brace":"^0.1.0","vue-bulma-breadcrumb":"^1.0.1","vue-bulma-card":"^1.0.2","vue-bulma-chartist":"^1.1.0","vue-bulma-chartjs":"^1.0.4","vue-bulma-collapse":"1.0.3","vue-bulma-datepicker":"^1.3.0","vue-bulma-emoji":"^0.0.2","vue-bulma-expanding":"^0.0.1","vue-bulma-jump":"^0.0.2","vue-bulma-message":"^1.1.1","vue-bulma-modal":"1.0.1","vue-bulma-notification":"^1.1.1","vue-bulma-pagination":"^1.2.0","vue-bulma-progress-bar":"^1.0.2","vue-bulma-progress-tracker":"0.0.4","vue-bulma-quill":"0.0.1","vue-bulma-rating":"^1.0.1","vue-bulma-slider":"^1.0.2","vue-bulma-switch":"^1.0.4","vue-bulma-tabs":"1.1.2","vue-bulma-tooltip":"^1.0.3","vue-cleave":"1.1.1","vue-context-menu":">= 2.0.6","vue-ctk-date-time-picker":"1.4","vue-js-popover":">=1.1.7","vue-lory":"0.0.4","vue-monthly-picker":"^0.2.8","vue-multiselect":"^2.1.0","vue-nprogress":"0.1.5","vue-peity":"0.5.0","vue-router":"3.0.1","vue-socket.io":"^2.1.1-b","vue-spinner":"^1.0.3","vue-template-compiler":"2.5.16","vuex":"3.0.1","vuex-router-sync":"5.0.0","wysiwyg.css":"0.0.2"},"devDependencies":{"autoprefixer":"^6.7.7","babel-core":"^6.21.0","babel-eslint":"^7.1.1","babel-loader":"^6.4.0","babel-plugin-transform-export-extensions":"^6.8.0","babel-preset-es2015":"^6.14.0","babel-preset-stage-2":"^6.17.0","connect-history-api-fallback":"^1.3.0","cross-env":"^3.1.3","css-loader":"^0.27.1","electron-devtools-installer":"^2.0.1","eslint":"^3.17.1","eslint-config-standard":"^7.0.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^2.1.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^2.0.0-beta.4","file-loader":"^0.10.1","html-webpack-plugin":"^2.25.0","http-proxy-middleware":"^0.17.4","imports-loader":"^0.7.0","node-sass":"^4.1.1","ora":"^1.1.0","original":"^1.0.0","postcss-loader":"^1.3.3","progress-bar-webpack-plugin":"^1.9.1","sass-loader":"^6.0.3","serve-favicon":"^2.4.1","string-replace-loader":"^2.1.1","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.7","vue-html-loader":"^1.2.3","vue-loader":"^11.1.4","vue-template-compiler":"^2.2.2","webpack":"^2.2.1","webpack-dev-middleware":"^1.9.0","webpack-hot-middleware":"^2.14.0","webpack-merge":"^4.0.0"}}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 369 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 370 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 371 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 372 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 373 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 374 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 375 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 376 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 377 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(138);


/***/ })
],[378]);


// WEBPACK FOOTER //
// assets/js/app.99f15e8f1029b64817ab.js